import type { OfferCheckoutRequest } from '@/data/catalog/offer/interfaces';
import { PaymentMethod } from '@/data/catalog/offer/interfaces';
import type { RegistrationFormData } from '@/packages/courses/components/user-data-form/schema';
import type {
  CreditCardFormData,
  InstallmentsFormData,
} from '@/packages/courses/pages/checkout/schema';
import { extractNumbers } from '@/utils/extract-numbers';

interface BuildCheckoutPayloadOptions {
  amount?: number;
  customerInfo: RegistrationFormData;
  paymentMethod: PaymentMethod;
  subscriptionId: number;
  creditCardData?: CreditCardFormData;
  installmentsData?: InstallmentsFormData;
  idToken?: string;
  coupon?: string;
}

export const buildCheckoutPayload = ({
  amount,
  customerInfo,
  paymentMethod,
  subscriptionId,
  creditCardData,
  installmentsData,
  idToken = '',
  coupon = '',
}: BuildCheckoutPayloadOptions): OfferCheckoutRequest => {
  const isCreditCard = paymentMethod === PaymentMethod.Card;
  const [exp_month, exp_year] = creditCardData?.expiration
    ? creditCardData.expiration.split('/')
    : ['', ''];

  return {
    coupon: coupon ?? '',
    address: customerInfo.street,
    address_number: customerInfo.number,
    city: customerInfo.city,
    complement: customerInfo.complement || '',
    district: customerInfo.neighborhood,
    document: extractNumbers(customerInfo.cpf),
    email: customerInfo.email,
    home_phone: extractNumbers(customerInfo.phone),
    idToken,
    mobile_phone: extractNumbers(customerInfo.phone),
    name: customerInfo.name,
    paymentData: {
      amount: isCreditCard ? amount ?? '' : '',
      cpf: creditCardData?.holder_document
        ? extractNumbers(creditCardData.holder_document)
        : '',
      cvv: isCreditCard ? creditCardData?.cvv || '' : '',
      exp_month: isCreditCard ? exp_month : '',
      exp_year: isCreditCard ? exp_year : '',
      holder_name: isCreditCard ? creditCardData?.holder_name || '' : '',
      installments: isCreditCard ? installmentsData?.installments || 1 : 1,
      number: isCreditCard
        ? creditCardData?.number
          ? extractNumbers(creditCardData.number)
          : ''
        : '',
    },
    payment_method: paymentMethod,
    state: customerInfo.state,
    subscriptionId,
    zip_code: extractNumbers(customerInfo.cep),
  };
};
